import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { BannerWithTabGroupItem } from '@promo/const';
import { SdvorSwiperComponent } from '@sdvor/shared/ui/v2';
import { DeviceService } from '@shared/services';
import { SwiperOptions } from 'swiper/types';

@Component({
  selector: 'sd-banner-with-tab-group',
  imports: [SdvorSwiperComponent],
  templateUrl: './banner-with-tab-group.component.html',
  styleUrls: ['./banner-with-tab-group.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BannerWithTabGroupComponent {
  @Input() bannersGroup: BannerWithTabGroupItem[];
  @Input() selectedGroup: string;

  @Output() selectGroup: EventEmitter<string> = new EventEmitter<string>();

  protected config: SwiperOptions = {
    slidesPerView: 'auto',
    spaceBetween: 8,
    navigation: { enabled: false },
    scrollbar: { enabled: false },
    breakpoints: {
      [this.deviceService.sizes.lg]: {
        spaceBetween: 15,
      },
    },
  };

  constructor(private deviceService: DeviceService) {}

  onSelect(groupLabel: string): void {
    this.selectGroup.emit(groupLabel);
  }

  isSelectedGroup(groupLabel: string): boolean {
    return this.selectedGroup === groupLabel;
  }
}
